import { useTranslation } from 'react-i18next';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageType,
  SupportiveMessageIconType,
  SupportiveMessageIconColor,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import styles from './AiImportInfoMessage.module.scss';

// Shown once any AI import option is selected: explains that Datizy will run AI
// over the supported files, and which file kinds it can/can't process.
export default function AiImportInfoMessage() {
  const { t } = useTranslation();

  return (
    <SupportiveMessage
      color={SupportiveMessageColor.Blue}
      type={SupportiveMessageType.FilledWithLeftBorder}
      iconType={SupportiveMessageIconType.FilledWithBorder}
      iconColor={SupportiveMessageIconColor.Inner}
      leftIcon="auto_awesome"
      leftIconSymbolsOutlined
      fullWidth
      text={
        <span className={styles.body}>
          <span>{t('documents-import-ai-info-title')}</span>
          <span className={styles.row}>
            <span className={styles.dot}>•</span>
            <span>
              <strong>{t('documents-import-ai-info-pdf-images')}</strong>
              {`: ${t('documents-import-ai-info-pdf-images-support')}`}
            </span>
          </span>
          <span className={styles.row}>
            <span className={styles.dot}>•</span>
            <span>
              <strong>{t('documents-import-ai-info-videos')}</strong>
              {`: ${t('documents-import-ai-info-videos-support')}`}
            </span>
          </span>
        </span>
      }
    />
  );
}
